<app-select-box
  [form]="fg"
  defaultOptionCaptionKey="Calculation.ShowPremiums"
  [showCallToActionButton]="true"
  [value]="value"
  placeholder="Calculation.ShowPremiums"
  [optionsList]="offersList"
  [control]="control"
  [textColor]="textColor"
  [fontFamily]="fontFamily"
  [inputBorderColor]="inputBorderColor"
  appConfigSettingsParagraph
  (selectedOption)="selectPremium($event)"
  [itemTemplate]="itemTemplate"
>
  <ng-template #itemTemplate let-item>
    <strong class="default-option">{{ item.text }}</strong>
    <span>{{ item.value | currency:'EUR':undefined:undefined:'nl' }}</span>
  </ng-template>
</app-select-box>
